/**
 * Agent-authored brief comment creation. Talks to the generated workspace-api
 * client directly (same as `features/comment-on-file`'s createComment) — a
 * feature-local wrapper because FSD boundaries forbid cross-feature imports.
 */
import {
  type CommentResponseDto,
  CommentsService,
  type CreateCommentDto,
} from '@inference.engine/workspace-api-client/web';
import { workspaceHttp } from '@/lib/api/http-client';
import { i18n } from '@/shared/i18n';

export const createAgentComment = async (
  projectId: string,
  target: { targetType: 'brief'; targetId: string },
  body: CreateCommentDto,
): Promise<CommentResponseDto> => {
  const response = await CommentsService.create({
    client: workspaceHttp,
    path: { platformProjectId: projectId },
    query: { targetType: target.targetType, targetId: target.targetId },
    body,
  });

  if (!response.data) {
    throw new Error(i18n.t('chats:briefAgentReview.agentCommentsApi.failedToCreateComment'));
  }

  return response.data;
};
